// SEO utility functions for updating meta tags dynamically

export interface SEOConfig {
  title?: string;
  description?: string;
  keywords?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
}

export const updatePageSEO = (config: SEOConfig) => {
  // Update document title
  if (config.title) {
    document.title = config.title;
  }

  // Update or create meta description
  if (config.description) {
    updateMetaTag('name', 'description', config.description);
  }

  // Update or create meta keywords
  if (config.keywords) {
    updateMetaTag('name', 'keywords', config.keywords);
  }

  // Update Open Graph tags
  if (config.ogTitle) {
    updateMetaTag('property', 'og:title', config.ogTitle);
  }

  if (config.ogDescription) {
    updateMetaTag('property', 'og:description', config.ogDescription);
  }

  if (config.ogImage) {
    updateMetaTag('property', 'og:image', config.ogImage);
  }
};

const updateMetaTag = (attribute: string, name: string, content: string) => {
  let element = document.querySelector(`meta[${attribute}="${name}"]`) as HTMLMetaElement;
  
  if (element) {
    element.content = content;
  } else {
    element = document.createElement('meta');
    element.setAttribute(attribute, name);
    element.content = content;
    document.head.appendChild(element);
  }
};

// Predefined SEO configurations for different pages
export const seoConfigs = {
  home: {
    title: "KSM - Restaurant Coréen à Nice, France",
    description: "Découvrez la cuisine coréenne authentique à Nice. KSM vous offre une expérience gastronomique coréenne unique dans une atmosphère moderne.",
    keywords: "KSM, restaurant coréen, Nice, France, cuisine coréenne, Korean restaurant, gastronomie asiatique",
    ogTitle: "KSM - Restaurant Coréen à Nice, France",
    ogDescription: "Découvrez la cuisine coréenne authentique à Nice. KSM vous offre une expérience gastronomique coréenne unique.",
  },
  about: {
    title: "À Propos de KSM - Histoire de la Marque et Recrutement",
    description: "Découvrez l'histoire de KSM et rejoignez notre équipe. Nous recherchons des talents passionnés pour promouvoir la culture culinaire coréenne à Nice, France.",
    keywords: "À propos KSM, histoire de la marque, recrutement, restaurant coréen Nice, emploi",
    ogTitle: "À Propos de KSM - Histoire de la Marque et Recrutement",
    ogDescription: "Découvrez l'histoire de KSM et rejoignez notre équipe passionnée.",
  },
  products: {
    title: "Menu KSM - Spécialités de Cuisine Coréenne",
    description: "Explorez le menu varié de KSM. Plateaux signature, plats principaux, accompagnements - découvrez les saveurs authentiques de la Corée à Nice.",
    keywords: "menu KSM, cuisine coréenne, plateaux signature, plats principaux, accompagnements, restaurant Nice",
    ogTitle: "Menu KSM - Spécialités de Cuisine Coréenne",
    ogDescription: "Explorez le menu varié de KSM. Découvrez les saveurs authentiques de la Corée.",
  },
};

// Function to generate dynamic SEO config for product detail pages
export const generateProductSEO = (productName: string, category: string, description: string, price?: string) => {
  return {
    title: `${productName} - Menu KSM ${category}`,
    description: `${description} ${price ? `Prix: ${price}€` : ''} Découvrez les détails de ${productName}, l'un des plats ${category} proposés par KSM et commandez dès maintenant.`,
    keywords: `${productName}, menu KSM ${category}, cuisine coréenne ${category}, prix ${productName}, commander ${productName}`,
    ogTitle: `${productName} - KSM ${category}`,
    ogDescription: `${description.substring(0, 100)}...`
  };
};
